// Vue 3 directive hooks: inserted -> mounted, unbind -> unmounted.
export default {
    mounted(el) {
        const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
        if (!input) return

        const handler = () => {
            setTimeout(() => {
                input.select()
            }, 10)
        }

        input.addEventListener('focus', handler)

        el.__vueSelectOnFocusHandler__ = handler
        el.__vueSelectOnFocusCleanUp__ = () => {
            input.removeEventListener('focus', el.__vueSelectOnFocusHandler__)
        }
    },

    unmounted(el) {
        if (el.__vueSelectOnFocusCleanUp__) {
            el.__vueSelectOnFocusCleanUp__()
            delete el.__vueSelectOnFocusCleanUp__
            delete el.__vueSelectOnFocusHandler__
        }
    },
}
